import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
  class: "min-h-screen"
};
const _hoisted_2 = {
  class: "bg-gradient-to-r from-orange-500 to-orange-600 shadow-lg mb-5 sm:mb-10"
};
const _hoisted_3 = {
  class: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"
};
const _hoisted_4 = {
  class: "flex justify-center items-center py-6 relative"
};
const _hoisted_5 = {
  key: 0,
  class: "search-code w-64 absolute right-0 hidden sm:block"
};
const _hoisted_6 = {
  class: ""
};
const _hoisted_7 = {
  key: 0,
  class: "py-16 text-center",
  role: "status"
};
const _hoisted_8 = {
  key: 1,
  class: "py-16 text-center",
  role: "alert"
};
const _hoisted_9 = {
  class: "py-5 app-footer my-6 mx-2 xl:max-w-[1200px] xl:mx-auto"
};
const _hoisted_10 = {
  class: "space-x-5 text-center"
};
const _hoisted_11 = {
  class: "text-sm space-x-3"
};
const _hoisted_12 = {
  class: "text-3xl flex justify-center gap-3 py-3"
};
import { ref, computed, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useHead } from '@vueuse/head';
import { useCommonStore } from '@/store/common';
import searchInput from './searchInput.vue';
export default {
  __name: 'LayoutPage',
  setup(__props) {
    const commonStore = useCommonStore();
    const route = useRoute();
    const brandData = computed(() => commonStore.brandData);
    const needsData = computed(() => route.name === 'Home' || route.name === 'couponDetail');
    const isLoading = ref(!commonStore.brandsLoaded);
    const loadError = ref(false);
    async function loadData() {
      isLoading.value = true;
      loadError.value = false;
      try {
        await commonStore.getBrandData();
      } catch (e) {
        loadError.value = true;
      } finally {
        isLoading.value = false;
      }
    }
    watch(needsData, needed => {
      if (needed && !commonStore.brandsLoaded) loadData();
    }, {
      immediate: true
    });
    if (typeof window !== 'undefined') useHead(computed(() => {
      const brand = brandData.value[route.params.url]?.brand_name?.trim() || '';
      const title = brand ? `${brand} Coupons & Promo Codes | PromoYeah` : 'PromoYeah – Coupon Codes & Deals';
      const meta = Object.entries(route.meta || {}).filter(([, value]) => typeof value === 'string').map(([key, value]) => ({
        ...(key.startsWith('og:') ? {
          property: key
        } : {
          name: key
        }),
        content: value.replace(/##/g, brand)
      }));
      return {
        title,
        meta
      };
    }));
    const gotoUrl = url => window.open(url, '_blank', 'noopener');
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      const _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("header", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_cache[3] || (_cache[3] = _createStaticVNode("<div class=\"flex items-center\"><svg class=\"h-10 w-10 text-white\" fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"currentColor\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z\"></path></svg><a href=\"/home\"><h1 class=\"ml-3 text-4xl sm:text-5xl font-extrabold text-white\"><span>promo</span><span class=\"text-yellow-300\">yeah</span></h1></a></div>", 1)), _unref(route).path === '/home' ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(searchInput, {
        data: brandData.value
      }, null, 8, ["data"])])) : _createCommentVNode("", true)])])]), _createElementVNode("main", _hoisted_6, [needsData.value && isLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_7, "Loading offers…")) : needsData.value && loadError.value ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_cache[4] || (_cache[4] = _createTextVNode("Unable to load offers. ")), _createElementVNode("button", {
        class: "underline",
        onClick: loadData
      }, "Try again")])) : (_openBlock(), _createBlock(_component_router_view, {
        key: 2
      }))]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createVNode(_component_router_link, {
        to: "/about-contact",
        rel: "nofollow, noindex"
      }, {
        default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode(" About & Contact")])),
        _: 1
      }), _createVNode(_component_router_link, {
        to: "/terms-conditions",
        rel: "nofollow, noindex"
      }, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode(" Terms & Conditions")])),
        _: 1
      }), _createVNode(_component_router_link, {
        to: "/cookie-policy",
        rel: "nofollow, noindex"
      }, {
        default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode(" Cookie & Policy")])),
        _: 1
      })])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("span", null, [_createElementVNode("button", {
        "aria-label": "twitter",
        style: {
          "background-color": "transparent",
          "border": "none",
          "padding": "0",
          "font": "inherit",
          "color": "inherit",
          "cursor": "pointer",
          "outline": "none"
        },
        onClick: _cache[0] || (_cache[0] = $event => gotoUrl('https://x.com/'))
      }, _cache[8] || (_cache[8] = [_createElementVNode("svg", {
        viewBox: "0 0 64 64",
        width: "32",
        height: "32"
      }, [_createElementVNode("circle", {
        cx: "32",
        cy: "32",
        r: "31",
        fill: "#000000"
      }), _createElementVNode("path", {
        d: "M 41.116 18.375 h 4.962 l -10.8405 12.39 l 12.753 16.86 H 38.005 l -7.821 -10.2255 L 21.235 47.625 H 16.27 l 11.595 -13.2525 L 15.631 18.375 H 25.87 l 7.0695 9.3465 z m -1.7415 26.28 h 2.7495 L 24.376 21.189 H 21.4255 z",
        fill: "white"
      })], -1)]))]), _createElementVNode("span", null, [_createElementVNode("button", {
        "aria-label": "facebook",
        style: {
          "background-color": "transparent",
          "border": "none",
          "padding": "0",
          "font": "inherit",
          "color": "inherit",
          "cursor": "pointer",
          "outline": "none"
        },
        onClick: _cache[1] || (_cache[1] = $event => gotoUrl('https://www.facebook.com/'))
      }, _cache[9] || (_cache[9] = [_createElementVNode("svg", {
        viewBox: "0 0 64 64",
        width: "32",
        height: "32"
      }, [_createElementVNode("circle", {
        cx: "32",
        cy: "32",
        r: "31",
        fill: "#3b5998"
      }), _createElementVNode("path", {
        d: "M34.1,47V33.3h4.6l0.7-5.3h-5.3v-3.4c0-1.5,0.4-2.6,2.6-2.6l2.8,0v-4.8c-0.5-0.1-2.2-0.2-4.1-0.2 c-4.1,0-6.9,2.5-6.9,7V28H24v5.3h4.6V47H34.1z",
        fill: "white"
      })], -1)]))]), _createElementVNode("span", null, [_createElementVNode("button", {
        "aria-label": "linkedin",
        style: {
          "background-color": "transparent",
          "border": "none",
          "padding": "0",
          "font": "inherit",
          "color": "inherit",
          "cursor": "pointer",
          "outline": "none"
        },
        onClick: _cache[2] || (_cache[2] = $event => gotoUrl('https://linkedin.com/'))
      }, _cache[10] || (_cache[10] = [_createElementVNode("svg", {
        viewBox: "0 0 64 64",
        width: "32",
        height: "32"
      }, [_createElementVNode("circle", {
        cx: "32",
        cy: "32",
        r: "31",
        fill: "#007fb1"
      }), _createElementVNode("path", {
        d: "M20.4,44h5.4V26.6h-5.4V44z M23.1,18c-1.7,0-3.1,1.4-3.1,3.1c0,1.7,1.4,3.1,3.1,3.1 c1.7,0,3.1-1.4,3.1-3.1C26.2,19.4,24.8,18,23.1,18z M39.5,26.2c-2.6,0-4.4,1.4-5.1,2.8h-0.1v-2.4h-5.2V44h5.4v-8.6 c0-2.3,0.4-4.5,3.2-4.5c2.8,0,2.8,2.6,2.8,4.6V44H46v-9.5C46,29.8,45,26.2,39.5,26.2z",
        fill: "white"
      })], -1)]))])]), _cache[11] || (_cache[11] = _createElementVNode("ul", {
        class: "space-y-2 wrap-s mb-3 text-xs text-left"
      }, [_createElementVNode("li", null, [_createElementVNode("b", null, "Disclaimer: "), _createTextVNode("This is an advertisement, not a recent news article, blogor consumer protection update. The information on the third-party!sites mentioned in this website changes over time, and we cannotpromise that the information on the website will be valid forever.")]), _createElementVNode("li", null, [_createElementVNode("b", null, "Marketing Disclosures: "), _createTextVNode("This website is a marketplace. Therefore.you should know that the website owner has a financial connectionwith the products and services advertised on the website. When aqualified lead is placed, the owner receives a sum of money, butnothing more.")]), _createElementVNode("li", null, [_createElementVNode("b", null, "Advertising Disclosure: "), _createTextVNode("This website and the products and servicesmentioned on the website are advertising marketplaces. This websiteis an advertisement, not a news publication. The owners of thiswebsite and the products and services mentioned on this website areonly providing a service through which consumers can obtain andcompare information.")])], -1)), _cache[12] || (_cache[12] = _createElementVNode("div", {
        class: "text-sm text-center"
      }, "©2025 promoyeah.com, All rights reserved", -1))])]);
    };
  }
};